import { useState } from "react";

import storageManager from "@/lib/storageManager";

export const useNavigation = (): {
  displayAreaDetail: boolean;
  setDisplayAreaDetail: (_: boolean) => void;
  opacity: number;
  setOpacity: (_: number) => void;
  displayNavi: number;
  setDisplayNavi: (_: number) => void;
  editable: number;
  setEditable: (_: number) => void;
  showMachineList: boolean;
  toggleMachineList: () => void;
  hideMachineList: () => void;
} => {
  const [displayAreaDetail, setDisplayMapAreaDetail] = useState<boolean>(true);
  const [opacity, setMapOpacity] = useState<number>(Number(storageManager.getLayoutMapOpacity()));
  const [displayNavi, setMapDisplayNavi] = useState<number>(Number(storageManager.getLayoutMapNaviDisplay()));
  const [editable, setMapEditable] = useState<number>(1);
  const [showMachineList, setShowMachineList] = useState<boolean>(true);

  const setDisplayAreaDetail = (value: boolean) => {
    setDisplayMapAreaDetail(value);
  };
  const setOpacity = (value: number) => {
    setMapOpacity(value);
    storageManager.setLayoutMapOpacity(value);
  };
  const setDisplayNavi = (value: number) => {
    setMapDisplayNavi(value);
    storageManager.setLayoutMapNaviDisplay(value);
  };
  const setEditable = (value: number) => {
    setMapEditable(value);
  };
  const toggleMachineList = () => {
    setShowMachineList(!showMachineList);
  };
  const hideMachineList = () => {
    setShowMachineList(false);
  };

  return {
    displayAreaDetail,
    setDisplayAreaDetail,
    opacity,
    setOpacity,
    displayNavi,
    setDisplayNavi,
    editable,
    setEditable,
    showMachineList,
    toggleMachineList,
    hideMachineList,
  };
};
